import React from "react";
import ReactDOM from "react-dom/client";
// Core styles required for Mantine
import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dates/styles.css";
import "./index.css";

import App from "./App";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import reportWebVitals from "./reportWebVitals";
import { Route, HashRouter,BrowserRouter, Routes } from "react-router-dom";
import { store, persistor } from "./components/Store/Store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "react-toastify/dist/ReactToastify.css";

// Ensure root element exists
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found. Check your index.html.");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <MantineProvider withGlobalStyles withNormalizeCSS>
            <ModalsProvider>
              <Routes>
                <Route path="*" element={<App />} />
              </Routes>
            </ModalsProvider>
          </MantineProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
